var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.874183,115.639875 L140.360125,5.12581653 C133.525703,-1.70860551 122.474297,-1.70860551 115.639875,5.12581653 L5.12581653,115.639875 C-1.70860551,122.474297 -1.70860551,133.525703 5.12581653,140.360125 L115.639875,250.874183 C122.474297,257.708606 133.525703,257.708606 140.360125,250.874183 L250.874183,140.360125 C257.708606,133.525703 257.708606,122.474297 250.874183,115.639875 Z M128,157.082647 L98.917353,128 L128,98.917353 L157.082647,128 L128,157.082647 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,115.781385 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L5.60948421,115.781385 C-1.20329116,122.594161 -1.20329116,133.610564 5.60948421,140.423339 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L250.579492,140.423339 C257.392268,133.610564 257.392268,122.594161 250.579492,115.781385 Z M128.094488,157.092896 L99.1039547,128.102362 L128.094488,99.1118287 L157.085022,128.102362 L128.094488,157.092896 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,115.781385 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L5.60948421,115.781385 C-1.20329116,122.594161 -1.20329116,133.610564 5.60948421,140.423339 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L250.579492,140.423339 C257.392268,133.610564 257.392268,122.594161 250.579492,115.781385 Z M128.094488,157.092896 L99.1039547,128.102362 L128.094488,99.1118287 L157.085022,128.102362 L128.094488,157.092896 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,115.781385 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L5.60948421,115.781385 C-1.20329116,122.594161 -1.20329116,133.610564 5.60948421,140.423339 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L250.579492,140.423339 C257.392268,133.610564 257.392268,122.594161 250.579492,115.781385 Z M128.094488,157.092896 L99.1039547,128.102362 L128.094488,99.1118287 L157.085022,128.102362 L128.094488,157.092896 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.6912329%",
    y1: "26.4246968%",
    x2: "74.7335616%",
    y2: "80.1268651%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.02,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.1551264%",
    y1: "24.1550696%",
    x2: "76.173587%",
    y2: "76.1735302%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.1722121%",
    y1: "30.9694022%",
    x2: "58.4436815%",
    y2: "47.6614064%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.1722121%",
    y1: "30.9694022%",
    x2: "63.1545369%",
    y2: "52.1813471%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,115.781385 L209.992745,75.1946386 L181.002212,46.2041051 L128.094488,99.1118287 L157.085022,128.102362 L128.094488,157.092896 L75.1867646,210.000619 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L181.002212,210.000619 L209.992745,181.010086 L250.579492,140.423339 C257.392268,133.610564 257.392268,122.594161 250.579492,115.781385 Z",
    fill: "#4285F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.002212,46.2041051 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L75.1867646,46.2041051 L46.1962311,75.1946386 L5.60948421,115.781385 C-1.20329116,122.594161 -1.20329116,133.610564 5.60948421,140.423339 L46.1962311,181.010086 L75.1867646,210.000619 L128.094488,157.092896 L99.1039547,128.102362 L128.094488,99.1118287 L181.002212,46.2041051 Z",
    fill: "#4FC3F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.773511,7.0668849 C122.586287,0.254109528 133.60269,0.254109528 140.415465,7.0668849 L250.579492,117.230912 C253.768451,120.419871 255.507883,124.623498 255.652836,128.827126 C255.797788,124.18864 254.203309,119.405202 250.579492,115.781385 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L5.60948421,115.781385 C1.98566752,119.405202 0.39118818,124.18864 0.536140848,128.827126 C0.681093515,124.623498 2.42052552,120.419871 5.60948421,117.230912 L115.773511,7.0668849 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.2,
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,138.973812 L140.415465,249.13784 C133.60269,255.950615 122.586287,255.950615 115.773511,249.13784 L5.60948421,138.973812 C2.42052552,135.784854 0.681093515,131.581226 0.536140848,127.377599 C0.39118818,132.016084 1.98566752,136.799522 5.60948421,140.423339 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L250.579492,140.423339 C254.203309,136.799522 255.797788,132.161037 255.652836,127.377599 C255.507883,131.581226 253.768451,135.784854 250.579492,138.973812 Z",
    fill: "#1A237E",
    fillRule: "nonzero",
    opacity: 0.2,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.094488,157.092896 L75.1867646,210.000619 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L181.002212,210.000619 L128.094488,157.092896 Z",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.579492,115.781385 L140.415465,5.61735822 C133.60269,-1.19541715 122.586287,-1.19541715 115.773511,5.61735822 L5.60948421,115.781385 C-1.20329116,122.594161 -1.20329116,133.610564 5.60948421,140.423339 L115.773511,250.587366 C122.586287,257.400142 133.60269,257.400142 140.415465,250.587366 L250.579492,140.423339 C257.392268,133.610564 257.392268,122.594161 250.579492,115.781385 Z M128.094488,157.092896 L99.1039547,128.102362 L128.094488,99.1118287 L157.085022,128.102362 L128.094488,157.092896 Z",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    mask: "url(#mask-8)",
    x: -11.0600725,
    y: -11.0521985,
    width: 278.309121,
    height: 278.309121
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.8,
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "128.581969 157.330709 150.838149 179.554685 95.9765726 230.529965 75.6850394 210.237441"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.8,
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "180.991418 46.4645669 203.247598 68.6885429 148.386021 119.663824 128.094488 99.3712997"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtm);
export default __webpack_public_path__ + "static/media/gtm.0a930283b610c5bfce1a09ed0a0e56dc.svg";
export { ForwardRef as ReactComponent };